import { DescribeNodeType } from '~/scenes/Automation/Flows/Actions/util/descriptionStandards';

const describeAppBBWaardecheckContactRequestNewCondition =
  (): DescribeNodeType =>
    'een nieuw BBWaardecheck contactverzoek is opgevraagd';

export default describeAppBBWaardecheckContactRequestNewCondition;
